import { render, staticRenderFns } from "./jimny.vue?vue&type=template&id=53893bc1&"
import script from "./jimny.vue?vue&type=script&lang=ts&"
export * from "./jimny.vue?vue&type=script&lang=ts&"
import style0 from "./jimny.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports